// @flow

import mapProductImagesToCarouselData from 'app/common/react/components/common/Carousel/utils/mapProductImagesToCarouselData';
import { type Pin } from 'app/common/react/components/PinRep/types';
import { type State as ReduxPin } from 'app/common/redux/reducers/pin';

export default function getCarouselData(pin: ReduxPin | Pin) {
  const productItem =
    pin && pin.product_pin_data && pin.product_pin_data.items && pin.product_pin_data.items[0];

  if (productItem && productItem.additional_images && productItem.additional_images.length > 0) {
    return mapProductImagesToCarouselData(
      pin.images,
      productItem,
      pin.carousel_data && pin.carousel_data.index,
    );
  }

  return pin.carousel_data;
}
